function subMenuHandler() {
  const parents = document.querySelectorAll('.nav__list-item--arrow');
  let activeParent = null;

  if (!parents) {
    return;
  }

  document.addEventListener('click', function (evt) {
    const target = evt.target;

    if (document.querySelector('.nav__sec-list.nav__sec-list--active') && !target.closest('.nav__list-item--arrow')) {
      const menu = document.querySelector('.nav__sec-list.nav__sec-list--active');
      const menuBtnIcon = document.querySelector('.nav__list-icon.nav__list-icon--active');

      menu.classList.remove('nav__sec-list--active');
      menuBtnIcon.classList.remove('nav__list-icon--active');

      return;
    }

    if (target.closest('.nav__list-item--arrow') && !target.closest('.nav__list-item--arrow a')) {
      if (document.querySelector('.nav__sec-list.nav__sec-list--active') && !target.closest('.nav__list-icon.nav__list-icon--active')) {
        document.querySelector('.nav__sec-list.nav__sec-list--active').classList.remove('nav__sec-list--active');
        document.querySelector('.nav__list-icon.nav__list-icon--active').classList.remove('nav__list-icon--active');
      }

      const parent = target.closest('.nav__list-item--arrow');
      const menu = parent.querySelector('.nav__sec-list');
      const menuBtnIcon = parent.querySelector('.nav__list-icon');

      menu.classList.toggle('nav__sec-list--active');
      menuBtnIcon.classList.toggle('nav__list-icon--active');
    }
  });
}

export { subMenuHandler };
